import { ModuleConfig } from "../../common/types";
import BusinessIcon from "@mui/icons-material/Business";
import EventIcon from "@mui/icons-material/Event";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import NewspaperIcon from "@mui/icons-material/Newspaper";

export const config: ModuleConfig = {
  id: "bkg",
  name: "Biotech Knowledge Graph",
  description:
    "Search and explore biotech companies, venture capital firms, and catalyst events.",
  startPage: "catalyst-events/digests", // Default page for BKG module
  hasTour: true, // Shows the sidebar "?" replay control; tour starts on the Companies page
  tourStartPage: "companies",
  routes: [
    {
      path: "companies",
      componentPath: "./modules/bkg/views/Search",
      requiredRole: "user",
    },
    {
      path: "companies/:company_id",
      componentPath: "./modules/bkg/views/CompanyProfile",
      requiredRole: "user",
    },
    {
      path: "catalyst-events",
      componentPath: "./modules/bkg/views/Event",
      requiredRole: "user",
    },
    {
      path: "venture-capital",
      componentPath: "./modules/bkg/views/VentureCapitalSearch",
      requiredRole: "user",
    },
    {
      path: "venture-capital/:venture_capital_id",
      componentPath: "./modules/bkg/views/VentureCapitalProfile",
      requiredRole: "user",
    },
    {
      path: "catalyst-events/digests",
      componentPath: "./modules/bkg/views/DigestList",
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
    {
      path: "catalyst-events/digests/new",
      componentPath: "./modules/bkg/views/DigestConfigForm",
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
    {
      path: "catalyst-events/digests/:config_id/edit",
      componentPath: "./modules/bkg/views/DigestConfigForm",
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
    {
      path: "catalyst-events/digests/:config_id/results",
      componentPath: "./modules/bkg/views/DigestResultsList",
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
    {
      path: "catalyst-events/digests/:config_id/results/:result_id",
      componentPath: "./modules/bkg/views/DigestView",
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
  ],
  navigation: [
    {
      path: "catalyst-events/digests",
      name: "Digests",
      icon: NewspaperIcon,
      requiredRole: "user",
      requiredFeature: "bkg_catalyst_digest",
    },
    {
      path: "companies",
      name: "Companies",
      icon: BusinessIcon,
      requiredRole: "user",
    },
    {
      path: "venture-capital",
      name: "Venture Capital",
      icon: AccountBalanceIcon,
      requiredRole: "user",
    },
    {
      path: "catalyst-events",
      name: "Catalyst Events",
      icon: EventIcon,
      requiredRole: "user",
    },
  ],
};
